import BalanceSection from "../components/BalanceSection/BalanceSection";

export default function BalancePage(){
    return <BalanceSection/>
}